import React, {useCallback, useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Box, Typography, Button, CircularProgress, TextareaAutosize} from '@material-ui/core';
import {useHistory, useLocation} from 'react-router-dom';
import {
 confirmInterpretation, createInterpretationRequest, exchangeToken,
 getInterpretationByHash,
 getInterpretationById, getInterpretationFields,
 getInterpretationOrderById,
 rejectInterpretation, 
} from "../api";
import AssayTable from "@cabinet-packages/pages/AssayTable";
import OrderInfo from "./OrderInfo";
import {AccessKey} from "@cabinet-packages/helpers";
import {useContext} from "react";
import {CatalogInetpretationContext} from "../index";

export const useStyles = makeStyles((theme) => ({
 subText: {
  fontSize: '0.8rem',
  opacity: 0.9,
 },
 formContainer: {
  border: '1px solid #1976d2',
  borderRadius: 6,
  padding: theme.spacing(2),
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
 },
 formTitle: {
  fontWeight: 600,
  marginBottom: theme.spacing(2),
  color: '#1976d2'
 },
 formButton: {
  marginTop: theme.spacing(1),
  borderColor: '#1976d2',
  color: '#1976d2',
  fontWeight: 500,
  '&:hover': {
   backgroundColor: '#e3f2fd',
  },
 },
 confirmButton: {
  borderColor: '#3377A4',
  backgroundColor: '#3377A4',
  color: 'white',
  minWidth: '110px',
  fontWeight: 500,
  borderRadius: 5,
  height: '40px',
  margin: '4px 0px',
  '&:hover': {
   color: '#1976d2',
   backgroundColor: '#e3f2fd',
  },
 },
 resultBox: {
  border: '1px solid #1976d2',
  borderRadius: 6,
  padding: theme.spacing(2),
  marginTop: theme.spacing(2),
  minHeight: 150,
 },
 textarea: {
  background: 'white',
  borderColor: '#1976d2',
  borderRadius: 5,
  width: '100%',
  padding: '4px'
 },
 textareaRoot: {
  borderRadius: 5
 },
 filtersHeaderRoot: {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
  marginBottom: '8px',
  flexWrap: 'wrap'
 }
}));

const OrderDetails = (...props) => {
 const [state, setState] = useContext(CatalogInetpretationContext)
//  const [state, setState] = React.useState({
//   order: null,
//   comment: '',
//   diagnos: '',
//   fields: null,
//   recomendation: '',
//   result: null,
//   l: false,
//   e: null
//  })
 const classes = useStyles();
 const location = useLocation();
 const params = new URLSearchParams(location.search);
 const hashId = params.get('forCatalog')
 const isId = +hashId > 0;
 const history = useHistory()

 const handleBack = () => {
  history.push(`/interpretation-list`);
 }

 const handleGetOrder = useCallback(async () => {
  if (!hashId) {
   return;
  }

  try {
   if (isId) {
    if (!state.order && !state.l) {
     setState(p => ({...p, l: true}))

     const order1 = await getInterpretationById(hashId)
     const order = {...order1, options: [...order1.options]}

     const result = await getInterpretationOrderById(order?.orderId)
     let fields = []
     if (order && order.options.includes('payed') && order.options.includes('approved') && order?.interpretationOrderId <= 0) {
      const res = await createInterpretationRequest(hashId)
      fields = await getInterpretationFields(res.data.id)
     } else if (order && order.options.includes('payed') && order?.interpretationOrderId > 0) {
      fields = await getInterpretationFields(order?.interpretationOrderId)

     }

     setState(p => ({...p, l: false, order, result, fields}))
    }

   } else {
    const newToken = await exchangeToken()
    const oldToken = AccessKey.get()

    if (newToken.token !== oldToken) {
     AccessKey.set(newToken.token)
    }

    const data = await getInterpretationByHash(hashId)

    history.push('/doctor-interpretation/' + data.id)
   }

  } catch (e) {
   console.error(e)
   setState(p => ({...p, l: false, e}))
  }

 }, [hashId])


 const handleConfirm = async (e) => {
  try {
   setState(p => ({...p, l: true}))

   await confirmInterpretation(state.order.id)
   const res = await createInterpretationRequest(hashId)
   const fields = await getInterpretationFields(res.data.id)

   const order = await getInterpretationById(hashId)

   const result = await getInterpretationOrderById(order?.orderId)

   setState(p => ({
    ...p,
    l: false,
    order,
    result,
    fields,
    e: order?.options?.includes('rejected') ? {message: 'Замовлення відхилено.'} : null
   }))
  } catch (e) {
   console.error(e)
   setState(p => ({...p, l: false, e}))
  }

 }

 const handleReject = async (e) => {
  try {
   setState(p => ({...p, l: true}))

   await rejectInterpretation(state.order.id)

   const order = await getInterpretationById(hashId)

   const result = await getInterpretationOrderById(order?.orderId)

   setState(p => ({...p, l: false, order, result, e: {message: 'Замовлення відхилено.'}}))
  } catch (e) {
   console.error(e)
   setState(p => ({...p, l: false, e}))
  }
 }



 useEffect(() => {
  if (hashId) {
   handleGetOrder()
  }
 }, [handleGetOrder, hashId])

 if (state.l) {
  return <CircularProgress size={48}/>
 }

 if (state?.e) {
  console.log(state.e)
  return <Box className={classes.formContainer}>
   <Typography className={classes.formTitle} style={{color: 'red'}}>
    {/*<em>Помилка:</em>*/}
    <br/>
    Замовлення вже прийнято іншим лікарем. Ви не можете взяти його в роботу.
    {/*<p style={{fontSize: '9px'}}>{state?.e?.message || ''}</p>*/}
   </Typography>
  </Box>
 }

 return (<Box height={'max-content'} maxWidth={'900px'} width={'100%'} margin={'4px'}>
  <Box className={classes.formContainer} height={'max-content'}>
   <Typography className={classes.formTitle}>
    Трактування результатів
   </Typography>
   <Button
    style={{borderRadius: 5,}}
    fullWidth
    variant="outlined"
    className={classes.formButton}
    onClick={handleBack}
   >
    Повернутись назад
   </Button>
   {/*{state?.order && !state?.order?.options?.includes('approved') && !state?.order?.options?.includes('payed') &&*/}
   {/* <Button fullWidth variant="outlined" className={classes.formButton} onClick={handleConfirm} disabled={!state.order}>Беру*/}
   {/*  в роботу</Button>}*/}
   {/*{!state?.order?.options?.includes('payed') &&*/}
   {/* <Button fullWidth variant="outlined" className={classes.formButton} onClick={handleReject}*/}
   {/*         disabled={!state.order}>Відхилити</Button>}*/}
   {state.order && <OrderInfo order={state.order} patient={true} goods={false} handleReject={handleReject} handleConfirm={handleConfirm}/>}
   {state?.order && <Box className={classes.resultBox}>
    <Typography variant="body2" style={{color: '#1976d2', fontWeight: 600}}>Результати аналізів</Typography>
    {!state?.order?.options?.includes('payed') || !state?.order?.options?.includes('approved')
     ? state?.order?.goods.map((i, idx) => <p key={i.id + 'idtest'}>
      {idx + 1}. {i.name}
     </p>)
     : state.result && <>
     <Box className={classes.resultBox}>
   <Typography variant="body2" style={{color: '#1976d2', fontWeight: 600}}>Нотатка п/з</Typography>
   {state?.result?.note ?? ''}
  </Box>
     <AssayTable id={state.order.orderId} patientId={state.order.patient.id} isDoctor={true} isExpanded={true}/>
    </>}
   </Box>}
    <Box className={classes.resultBox}>
   <Typography variant="body2" style={{color: '#1976d2', fontWeight: 600}}>Нотатка пацієнта</Typography>
   {state?.order?.note ?? ''}
  </Box>
 </Box>



  {state?.order?.options?.includes('payed') && state?.order?.options?.includes('approved') && <Box className={classes.formContainer} height={'max-content'}>
   <Typography variant="body2" style={{color: '#1976d2', fontWeight: 600}}>Трактування результатів</Typography>
   {state?.fields && state?.fields?.map((field, idx) => {
    return (<React.Fragment key={idx + field.testName}>
     <Typography variant="body2" style={{
      color: '#1976d2',
      fontWeight: 400,
      marginTop: '16px',
      marginBottom: '4px'
     }}>{field.testName}</Typography>
     <TextareaAutosize
      className={classes.textarea}
      label=""
      minRows={4}
      // disabled={state?.order?.options?.includes('done')}
      variant="outlined"
      value={state?.fields?.[idx]?.result}
      onChange={(e) => {
       e.persist()
       setState(p => ({
        ...p,
        fields: p?.fields?.map((i, index) => idx === index ? {...i, result: e.target.value} : i)
       }))
      }}
     />
    </React.Fragment>)
   })}

  </Box>}

 </Box>);
};

export default OrderDetails